import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import dayjs from "dayjs";

import { LanguageService } from "../services/language.service";
import { SentryService } from "../services/sentry.service";

@Pipe({
  name: "localizeDate",
  pure: false,
})
export class LocalizeDatePipe implements PipeTransform {
  constructor(
    private readonly languageService: LanguageService,
    private readonly sentryService: SentryService,
  ) {}

  public transform(value: any, pattern = "mediumDate"): string | null {
    if (!value) {
      return null;
    }
    const dayjsUtc = dayjs(value).utc();
    const utcDate = new Date(
      dayjsUtc.get("year"),
      dayjsUtc.get("month"),
      dayjsUtc.get("date"),
      dayjsUtc.get("hour"),
      dayjsUtc.get("minute"),
      dayjsUtc.get("second"),
    );

    try {
      return new DatePipe(this.languageService.locale).transform(
        utcDate,
        pattern,
      );
    } catch (error) {
      const message = `Error localizing date. Value: ${value}, Pattern: ${pattern}`;
      this.sentryService.captureException(message);
      console.error(message);
    }

    return null;
  }
}
